import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
	formStyle: {
		width: '100%',
		backgroundColor: 'blue',
	},
	containerForm: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
	},
	textField: {
		marginBottom: 10,
	},
}));
